import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppRoutes } from '../../hooks/useAppRoutes';
import FormulationBubblesStaticImage from '../../images/formulation-bubbles-static.png';
import { Briefing } from '../../types/briefing';
import { Heading } from '../Heading';
import { Icon } from '../Icon';
import { PackagingImage } from '../PackagingImage';
import { StatusIndicator } from '../StatusIndicator';

export type FormulationTileProps = { briefing: Briefing };

export const FormulationTile: FC<FormulationTileProps> = ({ briefing }) => {
  const { t, i18n } = useTranslation();
  const { projectOverviewRoute } = useAppRoutes();

  return (
    <Link to={`${projectOverviewRoute}/${briefing.key}`}>
      <div
        className="relative flex flex-col w-full text-center bg-center bg-cover border border-gray-500 h-96 hover:shadow-4dp"
        style={{
          backgroundImage: `url(${FormulationBubblesStaticImage})`,
        }}
      >
        <span className="absolute top-0 left-0 p-2 text-gray-700 uppercase bg-gray-300 text-2xs font-regular tracking-[3px]">
          {(briefing?.applications[0]?.data || '') as string}
        </span>
        <div className="mt-16 mb-1 mx-3" title={briefing.name}>
          <Heading
            level="h3"
            weight="medium"
            text={briefing.name}
            align="center"
            margin={0}
            truncate
          />
        </div>
        <div className="flex flex-col justify-between flex-grow">
          <div className="text-gray-600 font-regular">
            <p>{`${t('labels:createdAt')}: ${new Date(
              briefing.createdAt,
            ).toLocaleDateString(i18n.language?.replace('_', '-'))}`}</p>
            <p>{`${t('labels:createdBy')}: ${briefing.createdBy.first_name} ${
              briefing.createdBy.last_name
            }`}</p>
          </div>
          {briefing.packaging?.name && (
            <PackagingImage
              packagingValue={briefing.packaging.value}
              packagingName={briefing.packaging.name}
            />
          )}
          <div className="flex justify-center flex-initial">
            <StatusIndicator
              status={briefing.status}
              text={t(`labels:briefing:${briefing.status}`)}
            />
          </div>
          <div className="flex justify-center mt-3 mb-8 font-medium text-blue-200 hover:text-blue-100 hover:underline">
            <div>{t('linksOrButtons:details').toLocaleUpperCase()}</div>
            <div className="w-4">
              <Icon name="ArrowRight" inline={true} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
